import React from 'react';
import { GlobalStyles, theme } from '@bpba/ui-components';
import { ThemeProvider } from 'styled-components';
import ReactDOM from 'react-dom';
import './index.css';
import {App} from './App';

export type ConfigType = {
  REACT_CDN_BASE_URL?: string;
  REACT_API_BASE_URL?: string;
  NAVBAR_URL?: string;
  FOOTER_URL?: string;
};

ReactDOM.render(
  <React.StrictMode>
     <ThemeProvider theme={theme}>
      <GlobalStyles />
    <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
